<template>
  <div class="foot-content">
    <!-- <p>主办：中华人民共和国教育部</p>
    <p>网站运维：教育部教育技术与资源发展中心（中央电化教育馆）</p>
    <p>客服电话：4008980910 （工作日 8:30-17:00）</p> -->
    <div class="bottom">
      <div>
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202008423"
          target="_blank"
        >
          <img src="@/assets/jing-icon.png" width="15px" class="jing-icon" />
          京公网安备11010202008423号</a
        >
        <a
          href="https://beian.miit.gov.cn/"
          style="margin-left: 10px"
          target="_blank"
          >京ICP备16016202号-1</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
    };
  },
  methods: {
    // 点击搜索
    onSearch() {},
  },
};
</script>
<style lang="scss" scoped>
.foot-content {
  padding-top: 45px;
  font-size: 24px;
  color: white;
  text-align: center;

  p {
    margin: 0;
    line-height: 33px;
  }

  .bottom {
    margin-top: 5px;

    a {
      color: white;
    }

    div {
      text-align: center;
    }
  }
}
</style>
